// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_oh-8";
export var editMode = "_oh-3";
export var headerRow = "_oh-a";
export var headerTitle = "_oh-b";
export var product = "_oh-1";
export var productDetails = "_oh-5";
export var productDivider = "_oh-7";
export var productImage = "_oh-2";
export var productInfo = "_oh-4";
export var productTitle = "_oh-6";
export var strikethrough = "_oh-9";
export var upsellProductsCard = "_oh-0";